import script from "./members-list.vue?vue&type=script&setup=true&lang=js"
export * from "./members-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__